<template>
  <div class="additional-section-form">
    <div class="header">
      <p class="additional-section-form-title">Add a new section and/or field</p>
      <ts-button type="primary" size="small" circle @click="handleSectionRemoveClick()">
        <ts-icon icon="trash" size="x-small" color="#6d7587" />
      </ts-button>
    </div>
    <ts-form-item label="Section's name (optional)">
      <ts-input placeholder="Name your new section here" v-model.lazy="$v.form.name.$model"></ts-input>
    </ts-form-item>
    <ts-form-item
      v-for="(v, j) in $v.form.fields.$each.$iter"
      :key="j"
      :validation="v.name"
      label="Label of added field"
      class="form-item"
    >
      <div class="removable-input">
        <ts-input placeholder="Name your field here" v-model.lazy="v.name.$model"></ts-input>
        <ts-button type="primary" size="small" circle class="remove-field" @click="handleRemoveFieldClick(j)">
          <ts-icon icon="trash" size="x-small" color="#6d7587" />
        </ts-button>
      </div>
    </ts-form-item>
    <div class="add-item-button">
      <ts-divider>
        <ts-button size="small" circle @click="handleAddFieldClick">
          <ts-icon icon="plus" size="x-small" color="#6d7587" />
        </ts-button>
      </ts-divider>
    </div>
    <div class="actions">
      <ts-button @click="handleSaveClick">Save</ts-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.additional-section-form {
  padding: 30px;
  border-radius: 24px;
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(307deg, #000000 100%, var(--fills-neutral-white) -3%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
}

.additional-section-form-title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 10px;
}

.form-item {
  margin: 12px 0;
}

.removable-input {
  display: flex;
  align-items: center;

  .remove-field {
    margin-left: 12px;
  }
}

.add-item-button {
  margin-top: 60px;
}

.actions {
  width: 100%;
  margin-top: 60px;
  display: flex;
  justify-content: flex-end;
}

.header {
  display: flex;
  justify-content: space-between;
}
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: cloneDeep(this.value)
    };
  },
  validations: {
    form: {
      name: {},
      fields: {
        $each: {
          name: {
            required
          },
          value: {}
        }
      }
    }
  },
  methods: {
    handleAddFieldClick() {
      this.form.fields = [
        ...this.form.fields,
        {
          name: '',
          value: ''
        }
      ];
    },
    handleRemoveFieldClick(fieldIndex) {
      this.form.fields = this.form.fields.filter((_, i) => i !== parseInt(fieldIndex));
    },
    handleSectionRemoveClick() {
      this.$emit('delete', this.form);
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
      }
    }
  }
};
</script>
